import * as path from 'node:path';
import { isCliImmediateShutdownRequested } from '../../runtime/cli-process-interrupt.js';
import { yieldToEventLoop } from '../../runtime/yield-to-event-loop.js';
import { resolveIsolatedSessionParentPathFromCheckouts } from '../../paths/session-layout-paths.js';
import type { SessionWorktreeBinding } from '../session-worktree-binding.js';
import { collectWorktreeRootsNamed } from './collect-worktree-paths.js';

/**
 * Legacy `{layout}/{repoRel}/{sessionId}`: walk up from a checkout until `collectWorktreeRootsNamed` includes that
 * checkout, keeping the outermost match so multi-repo layouts resolve to the full set.
 */
export async function discoverLegacyBindingAscendingFromCheckout(
  sessionId: string,
  checkoutPath: string,
): Promise<SessionWorktreeBinding | null> {
  const sid = sessionId.trim();
  if (!sid) return null;
  const hintR = path.resolve(checkoutPath);
  let best: SessionWorktreeBinding | null = null;
  let cur = path.dirname(hintR);
  for (let i = 0; i < 40; i++) {
    if (isCliImmediateShutdownRequested()) return best;
    await yieldToEventLoop();
    const paths = await collectWorktreeRootsNamed(cur, sid);
    if (paths.paths.some((p) => path.resolve(p) === hintR)) {
      const isolated = resolveIsolatedSessionParentPathFromCheckouts(paths.paths) ?? path.resolve(paths.paths[0]!);
      best = {
        sessionParentPath: path.resolve(isolated),
        repoCheckoutPaths: paths.paths.map((p) => path.resolve(p)),
      };
    }
    const next = path.dirname(cur);
    if (next === cur) break;
    cur = next;
  }
  return best;
}
